var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPaintPalletActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7.457.99A12 12 0 0 1 23.54 7.991a4.325 4.325 0 0 1-.54 3.912 4.33 4.33 0 0 1-3.508 1.81h-3.205a2.571 2.571 0 0 0-.78 5.025c.943.351 1.603 1.203 1.666 2.204a2.451 2.451 0 0 1-1.731 2.613 11.66 11.66 0 0 1-3.22.444 12 12 0 0 1-6.233-1.75 12.094 12.094 0 0 1-5.73-11.078A12.094 12.094 0 0 1 7.457.989ZM7.714 12a2.572 2.572 0 1 0 0-5.144 2.572 2.572 0 0 0 0 5.144ZM18 6.857a2.571 2.571 0 1 1-5.142 0 2.571 2.571 0 0 1 5.142 0ZM7.714 18a1.714 1.714 0 1 0 0-3.429 1.714 1.714 0 0 0 0 3.429Z",
    fill: "#531DAB",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPaintPalletActive);
export default __webpack_public_path__ + "static/media/icon_paint_pallet_active.113df38686a6fa28506e9a2fe02e7831.svg";
export { ForwardRef as ReactComponent };